import Nav from "../../components/Nav/Nav.js";
import Hero from "../../components/Hero/Hero.js";
import Banner from "../../components/Banner/Banner.js";
import ShopCards from "../../components/ShopCards/ShopCards.js";
import Footer from "../../components/Footer/Footer.js";

function Home({ products }) {
  return (
    <>
      <Nav products={products}/>
      <Hero />
      <Banner />
      <ShopCards products={products} />
      <Footer />
    </>
  );
}

export default Home;
